import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsOptional } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import { GDSBookingItem } from "@/models/api/report/GDSBookingItem";

export class BookingReportItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  bookingItemId!: number | null;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @Expose()
  gds!: string;
  @IsString()
  @IsOptional()
  @Expose()
  pcccode!: string;
  @IsString()
  @Expose()
  agentId!: string;
  @IsOptional()
  @IsString()
  @Expose()
  cashier!: string | null;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @Expose()
  firstNumber!: string;
  @IsString()
  @Expose()
  passengerName!: string;
  @IsNumber()
  @Expose()
  totalAmount!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  ticketType!: string;
  @IsOptional()
  @IsString()
  @Expose()
  creationDate!: string | null;
  @IsNumber()
  @Expose()
  status!: number;
  @Expose()
  gdsBookingItem!: GDSBookingItem;
}

export class BookingReportItemResponse extends GenericTableResponse<BookingReportItem> {
  @Expose()
  @IsArray()
  @Type(() => BookingReportItem)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BookingReportItem>;
}
